import React, { useState } from 'react';
import apiClient from '../../api';

function Register({ openModal }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');
    try {
      const response = await apiClient.post('/register', { email, password });
      setMessage(`Registration successful for ${response.data.email}. Please check your inbox for a confirmation email.`);
      setMessageType('success');
    } catch (error) {
      const errorDetail = error.response?.data?.detail || error.response?.data?.message || error.message || 'An unknown error occurred.';
      setMessage('Error: ' + errorDetail);
      setMessageType('error');
    }
  };

  const handleSwitchToLogin = () => {
    if (typeof openModal === 'function') {
      openModal('login');
    } else {
      setMessage('Error: Cannot switch form.');
      setMessageType('error');
    }
  };

  return (
    <div>
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label>Password:</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <button type="submit">Register</button>
      </form>
      <p>Already have an account? <button onClick={handleSwitchToLogin}>Login here</button></p>
      {message && (
        <p className={messageType === 'success' ? 'success-message' : 'error-message'}>
          {message}
        </p>
      )}
    </div>
  );
}

export default Register;
